<template>
  <surround
    :surround-image="surroundImage"
    :title="title"
    :back-link="backLink"
  >
    <div v-if="loadedItems">
      <h1>{{ item.name }}</h1>
      <ContentText>
        <img
          v-if="item.image"
          :src="item.image"
        >
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="item.content" />
        <!-- eslint-enable -->
        <center>
          <button
            @click="popupModal"
          >
            Share
          </button>
        </center>
      </ContentText>
    </div>
    <p v-else>
      Loading...
    </p>
    <modal-popup
      ref="modal"
    >
      <template v-slot:header>
        <h1>
          Share
        </h1>
      </template>
      <template v-slot:body>
        <img
          v-if="item.image"
          :src="item.image"
        >
        <share-widget
          ref="sharer"
          :networks="['email', 'sms', 'facebook', 'twitter', 'pinterest']"
          :url="shareUrl"
          title="Host your own party like Roberto Burle Marx as he did in the Sítio, his home in Brazil. Try them all!"
          description="Host your own party like Roberto Burle Marx as he did in the Sítio, his home in Brazil. Try them all!"
          :image="item.image"
          @share="handleShare"
        />
      </template>
      <template v-slot:footer />
    </modal-popup>
  </surround>
</template>

<script>
import ShareWidget from '../components/ShareWidget'
import ModalPopup from '../components/ModalPopup'
import config from '../config.js'

export default {
  name: 'Recipe',
  components: {
    ShareWidget,
    ModalPopup
  },
  props: {
    recipe: {
      type: String,
      required: true
    },
    surroundImage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    }
  },
  data() {
      return {
          loadedItems: false
      }
  },
  computed: {
    item() {
      return this.loadedItems ? this.$store.getters.itemsDict.recipe[this.recipe] : {}
    },
    shareUrl() {
      return config.share_root + '/' + this.item.friendly + '/'
    }
  },
  beforeMount() {
    this.$store.dispatch('refreshItems', 'recipe').then(() => {
      this.loadedItems = true
    })
  },
  methods: {
    handleShare(event) {
      this.$gtm.trackEvent({
        category: 'Recipe',
        action: 'Share - ' + event,
        label: this.item.name
      })
    },
    popupModal() {
      this.$refs.modal.open()
    },
    popdownModal() {
      this.$refs.modal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
